export function isMacOs() {
    return navigator.platform.indexOf('Mac') > -1 || navigator.platform.indexOf('iPad') > -1;
}

export function isWindowsOs() {
    return navigator.platform.indexOf('Win') > -1;
}

export function isPortrait() {
    return window.innerHeight > window.innerWidth;
}